import StarIcon from "@mui/icons-material/Star";
import { Typography } from "@mui/material";
import { VerificationStatusChip } from "Components/Shared/Account/VerificationStatusChip";
import { BankAccountStatus } from "Infrastructure/Api/Api";
import { Resources, getResourcePath } from "Translations/Resources";
import { Trans } from "react-i18next";

const PageResources = Resources.Pages.Content.BankAccounts;

export const PrimaryAccountDescription = () => (
  <Typography display="inline" mt={2} lineHeight={1.7}>
    <StarIcon
      color="warning"
      sx={{ height: "1rem", width: "1rem", mb: -0.7, mr: 1 }}
    />
    <Trans
      i18nKey={getResourcePath(PageResources.PrimaryAccountDescription)}
      components={{
        limitedChip: (
          <VerificationStatusChip
            verificationStatus={BankAccountStatus.Restricted}
          />
        ),
        awaitingVerificationChip: (
          <VerificationStatusChip
            verificationStatus={BankAccountStatus.AwaitingVerification}
          />
        ),
      }}
    />
  </Typography>
);
